export default __webpack_public_path__ + "static/media/portfolio-128.06f7aaa7.jpg";